import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
/**
 * ### **SearchSidebarService**
 *
 * Un Servicio en Angular es el mecanismo para compartir funcionalidad entre componentes, en este caso se encarga de compartir
 * las funciones del SearchSidebarService hacen diferentes peticiones o llamados a distintos API's que genera el backend.
 *
 */
@Injectable({
  providedIn: 'root',
})
export class SearchSidebar {
  /** Variable que guarda la lista de categorias que tienen evento*/
  markerCategoriesFromEvent: number[] = [];
  /** Variable observable que permite tratar datos reactivamente*/
  isEventSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  /** @ignore*/
  constructor() {}

  /**
   * Función encargada de validar si hay algún evento,
   * @param markerCategories parametro que recibe el array de números de las categoria padre
   */
  validateIsEvent(markerCategories: number[]): void {
    const someIsEvent = markerCategories?.some(
      (m) => this.markerCategoriesFromEvent.indexOf(m) > -1,
    );
    // console.log(someIsEvent);
    this.isEventSubject.next(someIsEvent);
  }
}
